import React, { useEffect, useState } from 'react';
import { Button, Col, Drawer, Popconfirm, Row, Space, Table, Typography, Card, Tooltip } from 'antd';
import { openNotification } from '../../../utils';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { APP_LOCAL_DATE_FORMAT } from 'config/constants';
import { listInspectionAppointments, deleteInspectionAppointment } from '../services/inspection-appointmentService';
import InspectionAppointmentForm from './Form';
import TrashIcon from 'assets/icons/trash.svg';
import PenIcon from 'assets/icons/pen.svg';

export default function InspectionAppointmentList({ referenceId }: { referenceId?: number }){
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(false);
  const [editingId, setEditingId] = useState<number | undefined>();
  

  const fetchData = async () => {
    const res = await listInspectionAppointments(page-1, pageSize, 'startDate,asc');
    setData(res.content);
    setTotal(res.totalElements);
  };
  useEffect(() => { fetchData(); }, [page, pageSize]);
  const openCreate = () => { setEditingId(undefined); setOpen(true); };
  const openEdit = (id:number) => { setEditingId(id); setOpen(true); };
  const handleClose = () => setOpen(false);
  const handleDelete = async (id:number) => {
    try {
      await deleteInspectionAppointment(id);
      openNotification('success', 'Başarılı', 'Denetim Randevusu Silindi');
      fetchData();
    } catch (e) {
      openNotification('error', 'Hata', 'Denetim Randevusu silme işlemi başarısız');
    }
  };
  const columns = [
    { title: 'Firma', dataIndex: 'company.name', sorter: true, render: (_: any, r: any) => r?.company?.name },
    { title: 'Adres', dataIndex: 'address.name', sorter: true, render: (_: any, r: any) => r?.address?.name },
    { title: 'Yetkili Kişi', dataIndex: 'authorizedPerson.name', sorter: true, render: (_: any, r: any) => r?.authorizedPerson?.name },
    { title: 'Teklif', dataIndex: 'proposal', sorter: true },
    { title: 'Başlangıç', dataIndex: 'startDate', sorter: true, render: (v: string) => v ? dayjs(v).format(APP_LOCAL_DATE_FORMAT) : '' },
    { title: 'Bitiş', dataIndex: 'endDate', sorter: true, render: (v: string) => v ? dayjs(v).format(APP_LOCAL_DATE_FORMAT) : '' },
    { title: 'İşlemler', render: (_:any, r:any) => (
      <Space>
        <Link to={'/inspection-appointments/' + r.id}>
          <Button type='default' className='d-button action-button'>
            İşlemler
          </Button>
        </Link>
        <Tooltip title='Düzenle'>
          <Button
            icon={<img src={PenIcon} alt="pen" className="icon" />}
            shape="circle"
            onClick={() => openEdit(r.id)}
            className="icon-button"
          />
        </Tooltip>
        <Popconfirm title='Sil?' onConfirm={() => handleDelete(r.id)}>
          <Tooltip title='Sil'>
            <Button
              icon={<img src={TrashIcon} alt="trash" className="icon" />}
              shape="circle"
              className="icon-button ml-12px"
            />
          </Tooltip>
        </Popconfirm>
      </Space>
    ) }
  ];
  return (
    <>
      
      <Card
        className='br-30px'
        title={<Typography.Title level={4} style={{ margin: 0 }}>Denetim Randevusu</Typography.Title>}
        extra={<Button type='primary' onClick={openCreate}>Ekle</Button>}
      >
        <Table rowKey='id' dataSource={data} columns={columns} pagination={{ current: page, pageSize, total, onChange:(p,s)=>{setPage(p); setPageSize(s);} }} />
      </Card>
      <Drawer open={open} onClose={handleClose} destroyOnClose width={480} title={editingId ? 'Denetim Randevusu Düzenle' : 'Denetim Randevusu Oluştur'}>
        <InspectionAppointmentForm id={editingId} onSuccess={() => { handleClose(); fetchData();}} />
      </Drawer>
    </>
  );
}
